import {connect} from 'react-redux';
import {AgaroseGel as Component} from './AgaroseGel';
import {
  createAgaroseGel,
  // setAgaroseGelControlVisibility,
  setHeld,
  setHeldObject,
  showMoveMenu,
  setMoveMenu,

  hideAllControls,
  pushInteractions,
  setGelControlVisibility,
  setGelOnShelf,
  setGelInScene,
  setGelInBox,
  setGelHeld,
  setGelInTransilluminator
} from '@learningblocks/protocol-redux/lib/Actions';


//  const mapStateToProps = (state, ownProps) => {
//    return {
//        aria: ownProps.aria,
//        id: ownProps.id,
//        type: state.gel.gels[ownProps.id-1].type,
//        controlsVisible: state.gel.gels[ownProps.id-1].controlsVisible,
//        inScene: state.gel.gels[ownProps.id-1].inScene,
//        interactions: state.scene.interactions,
//        target: state.scene.lastDrop.lastTarget,
//        interactionProps: {
//          gelBoxes: state.gelBox.gelBoxes,
//        },
//        moveMenuDisplay: state.moveMenu.display,
//    }
// }

function mapStateToProps(state, ownProps) {
  if(state.notebook.protocolSection.scene.apparatus.hasOwnProperty("agaroseGel") &&
     state.notebook.protocolSection.scene.apparatus.agaroseGel.some(
       agaroseGel => agaroseGel.id === ownProps.id
     )
  ){
    return {
      id: ownProps.id,
      type: state.notebook.protocolSection.scene.apparatus.agaroseGel[ownProps.id-1].type,
      controlsVisible: state.notebook.protocolSection.scene.apparatus.agaroseGel[ownProps.id-1].controlsVisible,
      lastDrop: state.notebook.protocolSection.scene.lastDrop,
      heldObject: state.notebook.protocolSection.scene.heldObject,
      //aria: ownProps.aria,
      
      inScene: state.notebook.protocolSection.scene.apparatus.agaroseGel[ownProps.id-1].inScene,
       interactions: state.notebook.protocolSection.scene.interactions,
       target: state.notebook.protocolSection.scene.lastDrop.lastTarget,
       interactionProps: {
         gelBoxes: state.notebook.protocolSection.scene.apparatus.gelBoxes,
         transilluminator: state.notebook.protocolSection.scene.apparatus.transilluminator,
       },
    }
  } else {
    return {}
  }
}

function mapDispatchToProps(dispatch) {

  return {
    pushInteractions: (data) => {
      dispatch(pushInteractions(data))
    },
    setGelControlVisibility: (data) => {
      dispatch(setGelControlVisibility(data))
    },
    setGelOnShelf: (data) => {
      dispatch(setGelOnShelf(data))
    },
    setGelInScene: (data) => {
      dispatch(setGelInScene(data))
    },
    setGelInTransilluminator: (data) => {
      dispatch(setGelInTransilluminator(data))
    },
    setGelInBox: (data) => {
      dispatch(setGelInBox(data))
    },
    createAgaroseGel: (data) => {
      dispatch(createAgaroseGel(data))
    },
    setHeld: (data) => {
      dispatch(setHeld(data))
    },
    setGelHeld: (data) => {
      dispatch(setGelHeld(data))
    },
    setHeldObject: (data) => {
      dispatch(setHeldObject(data))
    },
    hideAllControls: (data) => {
      dispatch(hideAllControls(data))
    },
    showMoveMenu: (data) => {
      dispatch(showMoveMenu(data))
    },
    setMoveMenu: (data) => {
      dispatch(setMoveMenu(data))
    },
  };
}

export const AgaroseGel = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
